import { proxyFetchToApiRoute } from '@side/next-tools/client-middleware';
import createClient from 'openapi-fetch';
import type {
  AISchema,
  AuditSchema,
  CoreSchema,
  IdentitySchema,
  PaymentSchema,
} from './generated';

/**
 * openapi-fetch client for interacting with audit-service
 * @see https://docs.internal-services-stage.sideinc.dev/ui/service-calls
 * @see https://openapi-ts.dev/openapi-fetch/
 */
export const auditApi = createClient<AuditSchema.paths>({
  baseUrl: process.env.AUDIT_SERVICE_URL,
  // Make sure that datadog modified version of fetch is used so that trace headers are added
  fetch: (...args) => fetch(...args),
});

/**
 * openapi-fetch client for interacting with identity-service
 * @see https://docs.internal-services-stage.sideinc.dev/ui/service-calls
 * @see https://openapi-ts.dev/openapi-fetch/
 */
export const identityApi = createClient<IdentitySchema.paths>({
  baseUrl: process.env.IDENTITY_SERVICE_URL,
  // Make sure that datadog modified version of fetch is used so that trace headers are added
  fetch: (...args) => fetch(...args),
});

/**
 * openapi-fetch client for interacting with core-service
 * @see https://docs.internal-services-stage.sideinc.dev/ui/service-calls
 * @see https://openapi-ts.dev/openapi-fetch/
 */
export const coreApi = createClient<CoreSchema.paths>({
  baseUrl: process.env.CORE_SERVICE_URL,
  // Make sure that datadog modified version of fetch is used so that trace headers are added
  fetch: (...args) => fetch(...args),
});

/**
 * openapi-fetch client for interacting with payment-service
 * @see https://docs.internal-services-stage.sideinc.dev/ui/service-calls
 * @see https://openapi-ts.dev/openapi-fetch/
 */
export const paymentApi = createClient<PaymentSchema.paths>({
  baseUrl: process.env.PAYMENT_SERVICE_URL,
  // Make sure that datadog modified version of fetch is used so that trace headers are added
  fetch: (...args) => fetch(...args),
});

/**
 * openapi-fetch client for interacting with ai-service
 * @see https://docs.internal-services-stage.sideinc.dev/ui/service-calls
 * @see https://openapi-ts.dev/openapi-fetch/
 */
export const aiApi = createClient<AISchema.paths>({
  baseUrl: process.env.AI_SERVICE_URL,
  // Make sure that datadog modified version of fetch is used so that trace headers are added
  fetch: (...args) => fetch(...args),
});

if (typeof window === 'undefined') {
  // Server middleware — require() from a separate subpath so the bundler dead-code
  // eliminates this block (and its crypto dependency) from client bundles.
  const {
    addAuthAndTraceHeaders,
  } = require('@side/next-tools/server-middleware');
  // Server middleware
  auditApi.use(addAuthAndTraceHeaders);
  identityApi.use(addAuthAndTraceHeaders);
  coreApi.use(addAuthAndTraceHeaders);
  paymentApi.use(addAuthAndTraceHeaders);
  aiApi.use(addAuthAndTraceHeaders);
} else {
  // Browser middleware
  auditApi.use(proxyFetchToApiRoute('/api/proxies/audit'));
  identityApi.use(proxyFetchToApiRoute('/api/proxies/identity'));
  coreApi.use(proxyFetchToApiRoute('/api/proxies/core'));
  paymentApi.use(proxyFetchToApiRoute('/api/proxies/payment'));
  aiApi.use(proxyFetchToApiRoute('/api/proxies/ai'));
}
